import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Paper, Tab, Tabs } from "@mui/material";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import RuleOutlinedIcon from "@mui/icons-material/RuleOutlined";
import buildRoute from "components/buildRoute";
import PageHeader from "components/PageHeader";
import TemplatesList from "./components/TemplatesList";
import SchemasList from "./components/SchemasList";
import ColumnChecksList from "./components/ColumnChecksList";

const TABS = [
  { label: "All Templates", icon: <LayersOutlinedIcon />, id: "templates" },
  { label: "Schemas", icon: <TableChartOutlinedIcon />, id: "schemas" },
  { label: "Column Checks", icon: <RuleOutlinedIcon />, id: "column-checks" },
];

function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const FileUploaderAdminPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = parseInt(searchParams.get("tab") ?? "0", 10);
  const [currentTab, setCurrentTab] = useState(
    Number.isFinite(tabParam) && tabParam >= 0 && tabParam < TABS.length ? tabParam : 0
  );

  useEffect(() => {
    const t = parseInt(searchParams.get("tab") ?? "0", 10);
    if (Number.isFinite(t) && t >= 0 && t < TABS.length) setCurrentTab(t);
  }, [searchParams]);

  const handleTabChange = (_, newValue) => {
    setCurrentTab(newValue);
    setSearchParams({ tab: newValue });
  };

  return (
    <>
      <PageHeader
        title="File Uploader — Manage Templates"
        subtitle="Configure file templates, schemas, and user-specific validation rules."
      />

      <Paper sx={{ width: "100%", mt: 3 }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            aria-label="file uploader admin tabs"
          >
            {TABS.map((tab, idx) => (
              <Tab
                key={tab.id}
                icon={tab.icon}
                iconPosition="start"
                label={tab.label}
                id={`admin-tab-${idx}`}
                aria-controls={`admin-tabpanel-${idx}`}
              />
            ))}
          </Tabs>
        </Box>

        <Box sx={{ px: 3, pb: 3 }}>
          <TabPanel value={currentTab} index={0}>
            <TemplatesList />
          </TabPanel>
          <TabPanel value={currentTab} index={1}>
            <SchemasList />
          </TabPanel>
          <TabPanel value={currentTab} index={2}>
            <ColumnChecksList />
          </TabPanel>
        </Box>
      </Paper>
    </>
  );
};

export default buildRoute({ element: <FileUploaderAdminPage /> });
